// const POPUP_WIDTH = 400;
// const POPUP_HEIGHT = 426;
// const ACCESS_TOKEN_SWIGGY_AZURE_EVENT = "ACCESS_TOKEN_SWIGGY_AZURE_EVENT";

const serialize = function (obj: any) {
    const str = [];
    for (const p in obj)
        if (obj.hasOwnProperty(p)) {
            str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
        }
    return str.join('&');
};

export class OAuthService {
    private config = {
        CLIENT_ID: 'a2e28ebb-f2b6-4c81-8c73-331bcca424db',
        OAUTH_REDIRECT_URI: '/auth',
        OAUTH_LOGIN_ENPOINT: 'https://login.microsoftonline.com/12023edb-ff34-4574-a617-1a1af07b2e8f/oauth2/v2.0/',
    };

    public makeAuthUrl() {
        const queryParams = {
            client_id: `${this.config.CLIENT_ID}`,
            redirect_uri: `${window.location.origin}${this.config.OAUTH_REDIRECT_URI}`,
            response_type: 'code',
            scope: 'user.read',
            nonce: `&${Math.random().toString(36).substring(7)}`,
        };

        return `${this.config.OAUTH_LOGIN_ENPOINT}/authorize?${serialize(queryParams)}`;
    }

    public redirectUri() {
        return `${window.location.origin}${this.config.OAUTH_REDIRECT_URI}`;
    }

    // public launchPopup() {
    //   const left = window.screen.width / 2 - POPUP_WIDTH / 2,
    //     top = window.screen.height / 2 - POPUP_HEIGHT / 2;
    //   const win = window.open(
    //     this.makeAuthUrl(),
    //     "Swiggy Login",
    //     "menubar=no,location=no,resizable=no,scrollbars=no,status=no, width=" +
    //       POPUP_WIDTH +
    //       ", height=" +
    //       POPUP_HEIGHT +
    //       ", top=" +
    //       top +
    //       ", left=" +
    //       left
    //   );
    //   if (win) win.opener = window;
    // }

    public redirectToLogin() {
        window.location.href = this.makeAuthUrl();
    }

    // public listenToMessageEvent(resolve: any, reject: any) {
    //   const windowEventHandler = (event: MessageEvent) => {
    //     let hash = event.data;
    //     // eslint-disable-next-line no-console
    //     console.log(hash);
    //     if (hash.type === ACCESS_TOKEN_SWIGGY_AZURE_EVENT) {
    //       const token = hash.access_token;
    //       resolve(token);
    //     } else if (hash.type == "error") {
    //       console.error(hash.message);
    //       reject(hash.message);
    //     }
    //     window.removeEventListener("message", windowEventHandler);
    //   };
    //   window.addEventListener("message", windowEventHandler, false);
    // }

    // public findTokenInHash(hash: string): string | null {
    //   const matchedResult = hash.match(/access_token=([^&]+)/);
    //   return matchedResult && matchedResult[1];
    // }

    // public processToken(token: string, callbackFn: (token: string) => void) {
    //   if (!window.opener) {
    //     token && callbackFn(token);
    //     return;
    //   }
    //   if (!token) {
    //     window.opener.postMessage(
    //       {
    //         type: "error",
    //         message: "No Access Token Found.",
    //       },
    //       window.location.origin
    //     );
    //     window.close();
    //     return;
    //   }

    //   window.opener.postMessage(
    //     {
    //       type: ACCESS_TOKEN_SWIGGY_AZURE_EVENT,
    //       access_token: token,
    //     },
    //     window.location.origin
    //   );
    //   window.close();
    // }
}

export default new OAuthService();
